export enum NotificationCategory {
  WORK_ASSIGNMENT = "WORK_ASSIGNMENT",
  LEAVE_APPLICATION = "LEAVE_APPLICATION",
  WORK_ORDER_BILLING = "WORK_ORDER_BILLING",
  PAYMENT_EXPECTATION_FOLLOW_UP = "PAYMENT_EXPECTATION_FOLLOW_UP",
  PAYROLL = "PAYROLL",
  SECURITY = "SECURITY",
  WORK_ASSIGNMENT_REMOVAL = "WORK_ASSIGNMENT_REMOVAL",
  AMC_READY_FOR_ACTIVATION = "AMC_READY_FOR_ACTIVATION",
  AMC_ACTIVATION = "AMC_ACTIVATION",
  AMC_COMPLETION = "AMC_COMPLETION",
  AMC_CANCELLATION = "AMC_CANCELLATION",
}

/**
 * A notification's own source reference — independent of WorkAssignmentSourceType.
 * Values currently mirror it 1:1 because the only category today (WORK_ASSIGNMENT)
 * happens to point at the same kinds of entities. Extend this enum on its own terms
 * as more notification categories are added (e.g. QUOTATION, LEAVE_APPLICATION, INVOICE).
 */
export enum NotificationSourceType {
  WORK_ORDER = "WORK_ORDER",
  AMC = "AMC",
  AMC_VISIT = "AMC_VISIT",
  PETTY_WORK = "PETTY_WORK",
  SITE_VISIT = "SITE_VISIT",
  ENQUIRY = "ENQUIRY",
  LEAVE_APPLICATION = "LEAVE_APPLICATION",
  PAYMENT_EXPECTATION = "PAYMENT_EXPECTATION",
  PAYROLL_RUN = "PAYROLL_RUN",
  USER = "USER",
}

export interface NotificationActor {
  id: number;
  firstName: string;
  lastName: string;
  avatar?: string | null;
}

export interface NotificationSource {
  id?: number | null;
  code?: string | null;
  [key: string]: unknown;
}

export interface Notification {
  id: number;
  userId: number;
  actorUserId?: number | null;
  actor?: NotificationActor | null;
  category: NotificationCategory | string;
  title: string;
  message?: string | null;
  sourceType?: NotificationSourceType | string | null;
  sourceId?: number | null;
  source?: NotificationSource | null;
  isRead: boolean;
  readAt?: string | null;
  created_at: string;
}
